import m from "../../geodata/es2015/uaeLow";
window.am4geodata_uaeLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/uaeLow.js
// module id = null
// module chunks = 